import { VirtualSiteBatchUpdateEntityToBatchUpdateDto } from "src/app/features/VirtualSiteGroup/services/mappers/VirtualSiteBatchUpdateEntityToBatchUpdateDto";
import type { VirtualSiteBatchUpdateEntity } from "src/app/features/VirtualSiteGroup/types/VirtualSiteBatchUpdateEntity";
import { getAssignedDataGroup } from "../../../../core/router/auth";
import { ResourceName } from "../../../../core/router/config/ResourceName";
import { FORM_ACTION } from "../../../../core/router/types/routerTypes";
import { baseAuthApi } from "../../../../core/service/baseApi";
import type { FormMutation } from "../../../../core/service/types/FormMutation";
import type { ImportResult } from "../../../FeatureButtons/types";
import type { LoadVirtualSiteGroupSitesRequest, VirtualSiteGroupSitesResponse } from "./types";

export const virtualSiteGroupSitesApi = baseAuthApi.injectEndpoints({
    endpoints: (builder) => ({
        loadVirtualSiteGroupSites: builder.query<VirtualSiteGroupSitesResponse, LoadVirtualSiteGroupSitesRequest>({
            providesTags: ["mainCache"],
            query: ({ dataGroupCode, virtualSiteGroupId }) => ({
                url: `${ResourceName.DATA_GROUPS}/${dataGroupCode}/${ResourceName.VIRTUAL_SITE_GROUPS}/${virtualSiteGroupId}/${ResourceName.SITES}`,
                method: "GET",
            }),
        }),
        VirtualSiteBatchUpdate: builder.mutation<ImportResult, FormMutation<VirtualSiteBatchUpdateEntity>>({
            query: (mutation) => {
                const dataGroup = getAssignedDataGroup();

                const url = `${ResourceName.DATA_GROUPS}/${dataGroup?.code}/${ResourceName.VIRTUAL_SITE_GROUPS}/${FORM_ACTION.BATCH_UPDATE}`;
                const method = "PUT";

                const body = VirtualSiteBatchUpdateEntityToBatchUpdateDto(mutation.data);

                return {
                    url,
                    method,
                    body,
                };
            },
            transformResponse: (response: { successCount?: number; failedCount?: number; errors?: string[] }): ImportResult => ({
                importSuccessCount: response.successCount,
                importFailedCount: response.failedCount,
                importErrors: response.errors,
            }),
            invalidatesTags: ["mainCache"],
        }),
    }),
});

export const { useLoadVirtualSiteGroupSitesQuery, useVirtualSiteBatchUpdateMutation } = virtualSiteGroupSitesApi;
